$(document).ready(function () {

    $('.js-mailchimp-submit').on('click', function (e) {

        e.preventDefault();

        var form = $(this).closest('.js-mailchimp-form');
        var email = form.find('.js-mailchimp-email').val();

        var url = "../php/ajax/mailchimp.php?action=join";

        var post_data = {
            email: email
        };

        $.post(url, post_data, function (data) {

            try {
                var response = JSON.parse(data);

                if (response.valid) {
                    dialogify('<h2>Signed up</h2><p>Thank you, you have successfully joined our mailing list.</p>');
                    $('.js-mailchimp-email').val('');
                } else {
                    dialogify(response.error_message);
                }

            } catch (e) {
                dialogify(e + '<hr />' + data);
            }

        });

    });

});